import React, { useState } from 'react';
import classes from './Portfolio.module.scss';

// Import portfolio images
import zaziDating from '../../assets/zazidating_portfolio.png';
import palmistry from '../../assets/palmistry_portfolio.png';
import artistNextDoorWeb from '../../assets/artist_next_door_web_portfolio.png';
import artistNextDoor from '../../assets/artistnextdoor_portfolio.png';
import guruGaneshSaree from '../../assets/guruganeshsaree_portfolio.png';

const Portfolio = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      id: 1,
      title: 'ZAZI DATING',
      subtitle: 'Mobile App Development',
      description: 'Modern dating application with advanced matching algorithms, real-time messaging, and intuitive user interface designed to create meaningful connections.',
      image: zaziDating,
      category: 'Mobile',
      link: 'https://play.google.com/store/apps/details?id=com.zazidating',
      bgGradient: 'linear-gradient(135deg, rgb(229 134 144) 0%, rgb(219 103 130) 100%)'
    },
    {
      id: 2,
      title: 'PALMISTRY APP',
      subtitle: 'AI/ML Mobile Development',
      description: 'Advanced palmistry reading app using AI/ML for accurate predictions and personalized insights with cutting-edge computer vision technology.',
      image: palmistry,
      category: 'AI/ML',
      link: 'https://play.google.com/store/apps/details?id=com.palmaionline.palmistry',
      bgGradient: 'linear-gradient(135deg, rgb(96 27 48) 0%, rgb(98 47 54) 100%)'
    },

    {
      id: 3,
      title: 'ARTIST WEB & MOBILE DEVELOPMENT',
      subtitle: 'Mobile & Web App Development',
      description: 'Mobile companion app and webapp for artists to manage bookings, showcase work, and communicate with clients on the go.',
      image: artistNextDoorWeb,
      category: 'Mobile',
      link: 'https://artistnextdoor.in/',
      bgGradient: 'linear-gradient(135deg, rgb(133 89 200) 0%, rgb(52 29 89) 100%)'
    },
    {
      id: 4,
      title: 'E-COMMERCE STORE',
      subtitle: 'E-commerce Development',
      description: 'Modern e-commerce platform for traditional sarees with advanced filtering, wishlist, and seamless checkout experience.',
      image: guruGaneshSaree,
      category: 'E-commerce',
      link: 'https://guruganeshsaree.com/',
      bgGradient: 'linear-gradient(135deg, rgb(198 170 125) 0%, rgb(200 175 140) 100%)'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + projects.length) % projects.length);
  };

  return (
    <section id="portfolio" className={classes.portfolio}>
      <div className={classes.container}>
        <div className={classes.header}>
          <h2 className={classes.title}>Case Studies</h2>
        </div>

        <div className={classes.carousel}>
          <div className={classes.slideContainer}>
            <div
              className={classes.slides}
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {projects.map((project, index) => (
                <div
                  key={project.id}
                  className={classes.slide}
                  style={{ background: project.bgGradient }}
                >
                  <div className={classes.slideContent}>
                    <div className={classes.slideTop}>
                      <div className={classes.imageContainer}>
                        <img src={project.image} alt={project.title} />
                      </div>
                    </div>

                    <div className={classes.slideBottom}>
                      <div className={classes.slideHeader}>
                        <h3 className={classes.projectTitle}>{project.title}</h3>
                        <span className={classes.categoryBadge}>{project.category}</span>
                      </div>

                      <h4 className={classes.projectSubtitle}>{project.subtitle}</h4>

                      <p className={classes.projectDescription}>{project.description}</p>

                      <a href={project.link} className={classes.learnMoreBtn} target="_blank" rel="noopener noreferrer">
                        <span>Learn More</span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={classes.navigation}>
            <button
              className={`${classes.navBtn} ${classes.prevBtn}`}
              onClick={prevSlide}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>

            <button
              className={`${classes.navBtn} ${classes.nextBtn}`}
              onClick={nextSlide}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>

          <div className={classes.indicators}>
            {projects.map((_, index) => (
              <button
                key={index}
                className={`${classes.indicator} ${index === currentSlide ? classes.active : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
